import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-04f0932e"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "0.5盘 ", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "1.5盘 ", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "2.5盘 ", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "3.5盘 ", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "4.5盘 ", -1));
const _hoisted_6 = {
  class: "content"
};
const _hoisted_7 = {
  class: "content"
};
const _hoisted_8 = {
  class: "content"
};
const _hoisted_9 = {
  class: "content"
};
const _hoisted_10 = {
  class: "content"
};
const _hoisted_11 = {
  style: {
    "padding": "10px 2px"
  }
};
const _hoisted_12 = {
  style: {
    "padding": "10px 2px"
  }
};
const _hoisted_13 = {
  style: {
    "padding": "10px 2px"
  }
};
const _hoisted_14 = {
  style: {
    "padding": "10px 2px"
  }
};
const _hoisted_15 = {
  style: {
    "padding": "10px 2px"
  }
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "0.5盘 ", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "1.5盘 ", -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "2.5盘 ", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "3.5盘 ", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "4.5盘 ", -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, "赛果 ", -1));
const _hoisted_22 = {
  class: "content"
};
const _hoisted_23 = {
  class: "content"
};
const _hoisted_24 = {
  class: "content"
};
const _hoisted_25 = {
  class: "content"
};
const _hoisted_26 = {
  class: "content"
};
const _hoisted_27 = {
  class: "content"
};
import { ref } from 'vue';
import axios from 'axios';
export default {
  __name: 'TtgBJ',
  setup(__props, {
    expose: __expose
  }) {
    const show2 = ref(false);
    const type = ref(0);
    const matchWater = ref({});
    const flag05 = ref(true);
    const flag15 = ref(true);
    const flag25 = ref(false);
    const flag35 = ref(false);
    const flag45 = ref(false);
    const old = ref({});
    const list = ref([]);
    const title = ref('');
    // 显示弹出框
    const show = (water, t) => {
      old.value = water;
      show2.value = true;
      type.value = t;
      flag05.value = true;
      flag15.value = true;
      flag25.value = true;
      flag35.value = false;
      flag45.value = false;
      if (t == 0) {
        title.value = '同进球数比较';
        matchWater.value = {
          ttgUp05: water.Up05,
          ttgUp15: water.Up15,
          ttgUp25: water.Up25
        };
      } else if (t == 1) {
        title.value = '同比分进球数比较';
        matchWater.value = {
          crsUp05: water.Up05,
          crsUp15: water.Up15,
          crsUp25: water.Up25
        };
      }
      selectMatchGoalWater(matchWater.value);
    };
    const change05 = value => {
      if (value) {
        if (type.value == 0) {
          matchWater.value.ttgUp05 = old.value.Up05;
        } else {
          matchWater.value.crsUp05 = old.value.Up05;
        }
      } else {
        if (type.value == 0) {
          matchWater.value.ttgUp05 = null;
        } else {
          matchWater.value.crsUp05 = null;
        }
      }
      selectMatchGoalWater(matchWater.value);
    };
    const change15 = value => {
      if (value) {
        if (type.value == 0) {
          matchWater.value.ttgUp15 = old.value.Up15;
        } else {
          matchWater.value.crsUp15 = old.value.Up15;
        }
      } else {
        if (type.value == 0) {
          matchWater.value.ttgUp15 = null;
        } else {
          matchWater.value.crsUp15 = null;
        }
      }
      selectMatchGoalWater(matchWater.value);
    };
    const change25 = value => {
      if (value) {
        if (type.value == 0) {
          matchWater.value.ttgUp25 = old.value.Up25;
        } else {
          matchWater.value.crsUp25 = old.value.Up25;
        }
      } else {
        if (type.value == 0) {
          matchWater.value.ttgUp25 = null;
        } else {
          matchWater.value.crsUp25 = null;
        }
      }
      selectMatchGoalWater(matchWater.value);
    };
    const change35 = value => {
      if (value) {
        if (type.value == 0) {
          matchWater.value.ttgUp35 = old.value.Up35;
        } else {
          matchWater.value.crsUp35 = old.value.Up35;
        }
      } else {
        if (type.value == 0) {
          matchWater.value.ttgUp35 = null;
        } else {
          matchWater.value.crsUp35 = null;
        }
      }
      selectMatchGoalWater(matchWater.value);
    };
    const change45 = value => {
      if (value) {
        if (type.value == 0) {
          matchWater.value.ttgUp45 = old.value.Up45;
        } else {
          matchWater.value.crsUp45 = old.value.Up45;
        }
      } else {
        if (type.value == 0) {
          matchWater.value.ttgUp45 = null;
        } else {
          matchWater.value.crsUp45 = null;
        }
      }
      selectMatchGoalWater(matchWater.value);
    };

    // 关闭弹出框
    const close = () => {
      show2.value = false;
    };
    const loadingRef = ref(null);
    const selectMatchGoalWater = async water => {
      try {
        const response = await axios.post('http://111.229.73.205:8888/matchGoalWater/selectMatchGoalWater', water);
        let data = response.data;
        let waterList = [];
        for (let i = 0; i < data.length; i++) {
          if (type.value == 0) {
            waterList.push({
              Up05: data[i].ttgUp05,
              Up15: data[i].ttgUp15,
              Up25: data[i].ttgUp25,
              Up35: data[i].ttgUp35,
              Up45: data[i].ttgUp45,
              combination: data[i].combination
            });
          } else if (type.value == 1) {
            waterList.push({
              Up05: data[i].crsUp05,
              Up15: data[i].crsUp15,
              Up25: data[i].crsUp25,
              Up35: data[i].crsUp35,
              Up45: data[i].crsUp45,
              combination: data[i].combination
            });
          }
        }
        list.value = waterList;
        ;
      } catch (error) {
        // 处理错误
        console.error(error);
      }
    };

    // 暴露给外部使用的函数
    __expose({
      show,
      close
    });
    return (_ctx, _cache) => {
      const _component_nut_divider = _resolveComponent("nut-divider");
      const _component_nut_col = _resolveComponent("nut-col");
      const _component_nut_row = _resolveComponent("nut-row");
      const _component_nut_switch = _resolveComponent("nut-switch");
      const _component_nut_popup = _resolveComponent("nut-popup");
      return _openBlock(), _createBlock(_component_nut_popup, {
        visible: show2.value,
        "onUpdate:visible": _cache[5] || (_cache[5] = $event => show2.value = $event),
        style: {
          padding: '30px 10px',
          height: '80%',
          width: '85%',
          overflow: 'auto'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_nut_divider, {
          "content-position": "left"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(title.value), 1)]),
          _: 1
        }), _createVNode(_component_nut_row, null, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 4
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 4
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 4
          }, {
            default: _withCtx(() => [_hoisted_3]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 4
          }, {
            default: _withCtx(() => [_hoisted_4]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 4
          }, {
            default: _withCtx(() => [_hoisted_5]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_nut_row, null, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 4
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_6, _toDisplayString(old.value.Up05), 1)]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 4
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_7, _toDisplayString(old.value.Up15), 1)]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 4
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_8, _toDisplayString(old.value.Up25), 1)]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 4
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_9, _toDisplayString(old.value.Up35), 1)]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 4
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_10, _toDisplayString(old.value.Up45), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_nut_row, null, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createTextVNode(" 0.5："), _createVNode(_component_nut_switch, {
              modelValue: flag05.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => flag05.value = $event),
              onChange: change05
            }, null, 8, ["modelValue"])])]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createTextVNode(" 1.5"), _createVNode(_component_nut_switch, {
              modelValue: flag15.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => flag15.value = $event),
              onChange: change15
            }, null, 8, ["modelValue"])])]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createTextVNode(" 2.5"), _createVNode(_component_nut_switch, {
              modelValue: flag25.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => flag25.value = $event),
              onChange: change25
            }, null, 8, ["modelValue"])])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_nut_row, null, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createTextVNode(" 3.5："), _createVNode(_component_nut_switch, {
              modelValue: flag35.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => flag35.value = $event),
              onChange: change35
            }, null, 8, ["modelValue"])])]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createTextVNode(" 4.5"), _createVNode(_component_nut_switch, {
              modelValue: flag45.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => flag45.value = $event),
              onChange: change45
            }, null, 8, ["modelValue"])])]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 8
          })]),
          _: 1
        }), _createVNode(_component_nut_row, null, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 4
          }, {
            default: _withCtx(() => [_hoisted_16]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 4
          }, {
            default: _withCtx(() => [_hoisted_17]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 4
          }, {
            default: _withCtx(() => [_hoisted_18]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 4
          }, {
            default: _withCtx(() => [_hoisted_19]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 4
          }, {
            default: _withCtx(() => [_hoisted_20]),
            _: 1
          }), _createVNode(_component_nut_col, {
            span: 4
          }, {
            default: _withCtx(() => [_hoisted_21]),
            _: 1
          })]),
          _: 1
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (up, index) => {
          return _openBlock(), _createBlock(_component_nut_row, {
            key: index
          }, {
            default: _withCtx(() => [_createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_22, _toDisplayString(up.Up05), 1)]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_23, _toDisplayString(up.Up15), 1)]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_24, _toDisplayString(up.Up25), 1)]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_25, _toDisplayString(up.Up35), 1)]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_26, _toDisplayString(up.Up45), 1)]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_27, _toDisplayString(up.combination), 1)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }, 8, ["visible"]);
    };
  }
};